import Vue from 'vue';
import Amplify from 'aws-amplify';

import App from './App.vue';
import VueRouter from 'vue-router'
import store from './store/store';
import VueNativeSock from 'vue-native-websocket'


//helper
import './config/fontawesome';
import 'vue-slider-component/theme/default.css';

//components
import Whiteboard from './components/WhiteBoard'
import HelloWorld from './components/HelloWorld'

Vue.use(VueNativeSock, 'wss://o9mtupxxo4.execute-api.eu-central-1.amazonaws.com/prod', {
  store: store,
  connectManually: true,
})

import vuetify from './plugins/vuetify';

Amplify.configure({
  // OPTIONAL - if your API requires authentication 
  // Auth: {
  //   // REQUIRED - Amazon Cognito Identity Pool ID
  //   identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
  //   // REQUIRED - Amazon Cognito Region
  //   region: 'XX-XXXX-X',
  //   // OPTIONAL - Amazon Cognito User Pool ID
  //   userPoolId: 'XX-XXXX-X_abcd1234',
  //   // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  //   userPoolWebClientId: 'a1b2c3d4e5f6g7h8i9j0k1l2m3',
  // },
  API: {
    endpoints: [{
        name: 'WhiteBoardAPI',
        endpoint: 'https://du3yv27oud.execute-api.eu-central-1.amazonaws.com/prod'
      }
    ]
  }
});

Vue.use(VueRouter)

const routes = [

  {
    path: '',
    name: 'whiteboard',
    component: Whiteboard  
  }, 
  {
    path: '/board/:id',
    component: Whiteboard
  }, 
  {
    path: '/hello',
    component: HelloWorld
  },
  {
    path: '*',
    component: Whiteboard
  }
]

const router = new VueRouter({
  routes
})

Vue.config.productionTip = false;

const app = new Vue({
  render: h => h(App),
  router,
  vuetify,
  store
}).$mount('#app');

store.$app = app